<div class="p-6" data-element="unpublish-dialog-container">
  <div class="flex justify-between items-center mb-4" data-element="unpublish-dialog-header">
    <h3 class="m-0">Are you sure you want to unpublish this {{ data.type | humanize }}?</h3>
    <sbnb-close (click)="dialogRef.close()" data-element="unpublish-dialog-close"></sbnb-close>
  </div>
  <div class="flex flex-col gap-4" data-element="unpublish-dialog-content">
    <p class="m-0">
      This action is not advised if you have already shared this
      {{ data.type | humanize }} PDF with your Owner.
    </p>
    <ul class="list">
      <li>
        Unpublishing this {{ data.type | humanize }} will unlock relevant reservations, transactions and commission
        calculations so that they can be changed.
      </li>
      <li *ngIf="accountingConnected$ | async">
        Data pushed to your accounting software associated with this {{ data.type | humanize }} will be removed.
      </li>
    </ul>
    <div class="flex justify-between mt-4">
      <ng-container *ngTemplateOutlet="nevermindButton"></ng-container>
      <sbnb-button
        label="Unpublish"
        (click)="dialogRef.close('unpublish')"
        data-element="confirm-unpublish-button"></sbnb-button>
    </div>
  </div>
</div>

<ng-template #nevermindButton>
  <sbnb-button
    type="secondary"
    label="Cancel"
    (click)="dialogRef.close()"
    data-element="cancel-button"></sbnb-button>
</ng-template>
